export default {
    'SET_CHAMADOS'(state, chamados) {
        state.chamados = chamados
    },

    'SET_CONVERSA'(state, protocolo) {
        let chamados = state.chamados

        let conversa

        for(let i in chamados) {
            if(chamados[i].protocolo == protocolo)
                conversa = chamados[i].historico
        }

        state.conversa = conversa
    },

    'SET_GRUPOS'(state, grupos) {
        state.grupos = grupos
    },

    /*'SET_GRUPOAGENTES'(state, grupos) {
        state.grupoagentes = grupos
    },*/

    'SET_TAXISTAS'(state, taxistas) {
        state.taxistas = taxistas
    },

    'SET_AGENTES'(state, agentes) {
        state.agentes = agentes
    },

    'SET_GROUPSMANAGER' (state, groups) {

        //console.log('mutation', groups)
        state.grupo_agentes  = groups.find( g => g.nome == "agentes" ) && groups.find( g => g.nome == "agentes" )._id,
        state.grupo_taxistas =  groups.find( g => g.nome == "taxistas" ) && groups.find( g => g.nome == "taxistas" )._id
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/pxtalk/mutations.js